import { Button } from "../../../../components/ui/button";
import { Input } from "../../../../components/ui/input";
import { Textarea } from "../../../../components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../../components/ui/select";
import { Plus, Save } from "lucide-react";
import { Field } from "./shared";
import { NEW_LEDGER_OPTION } from "./constants";

const NO_BANK_ACCOUNT = "__none__";

export default function FixedDepositForm({ form, setForm, bankAccounts, availableLedgers, fieldsLocked, ledgerLocked, busy, onSubmit, onCancel, submitLabel, isEdit }) {
  return (
    <div>
      <div className="grid gap-3 md:grid-cols-4">
        <Field label="Bank account (optional)">
          <Select
            value={form.bankAccountId || NO_BANK_ACCOUNT}
            onValueChange={(v) => {
              const account = bankAccounts.find((a) => a.id === v);
              setForm((f) => ({ ...f, bankAccountId: v === NO_BANK_ACCOUNT ? "" : v, bankName: account ? account.bankName : f.bankName }));
            }}
          >
            <SelectTrigger><SelectValue placeholder="Not linked to a Bank Account record" /></SelectTrigger>
            <SelectContent>
              <SelectItem value={NO_BANK_ACCOUNT}>Not linked (enter bank name manually)</SelectItem>
              {bankAccounts.map((a) => <SelectItem key={a.id} value={a.id}>{a.bankName} - {a.accountName || a.accountNumber}</SelectItem>)}
            </SelectContent>
          </Select>
        </Field>
        <Field label="Bank name">
          <Input value={form.bankName} onChange={(e) => setForm((f) => ({ ...f, bankName: e.target.value }))} placeholder="HDFC Bank" disabled={!!form.bankAccountId} />
        </Field>
        <Field label="FD number">
          <Input value={form.fdNumber} onChange={(e) => setForm((f) => ({ ...f, fdNumber: e.target.value }))} disabled={fieldsLocked} />
        </Field>
        <Field label="Instrument / account name">
          <Input value={form.instrumentName} onChange={(e) => setForm((f) => ({ ...f, instrumentName: e.target.value }))} />
        </Field>
        <Field label="Principal">
          <Input type="number" min="0" value={form.principal} onChange={(e) => setForm((f) => ({ ...f, principal: e.target.value }))} disabled={fieldsLocked} />
        </Field>
        <Field label="Start date">
          <Input type="date" value={form.startDate} onChange={(e) => setForm((f) => ({ ...f, startDate: e.target.value }))} disabled={fieldsLocked} />
        </Field>
        <Field label="Maturity date">
          <Input type="date" value={form.maturityDate} onChange={(e) => setForm((f) => ({ ...f, maturityDate: e.target.value }))} disabled={fieldsLocked} />
        </Field>
        <Field label="Interest rate (%)">
          <Input type="number" min="0" step="0.01" value={form.interestRate} onChange={(e) => setForm((f) => ({ ...f, interestRate: e.target.value }))} disabled={fieldsLocked} />
        </Field>
        <Field label="Maturity value">
          <Input type="number" min="0" value={form.maturityValue} onChange={(e) => setForm((f) => ({ ...f, maturityValue: e.target.value }))} disabled={fieldsLocked} />
        </Field>
        <Field label="Linked accounting ledger (Asset)">
          <Select disabled={fieldsLocked || ledgerLocked} value={form.linkedLedgerId} onValueChange={(v) => setForm((f) => ({ ...f, linkedLedgerId: v }))}>
            <SelectTrigger><SelectValue placeholder="Select an Asset-group ledger" /></SelectTrigger>
            <SelectContent>
              <SelectItem value={NEW_LEDGER_OPTION}>+ Create a new ledger for this FD</SelectItem>
              {availableLedgers.map((l) => <SelectItem key={l.id} value={l.id}>{l.name}</SelectItem>)}
            </SelectContent>
          </Select>
          {(fieldsLocked || ledgerLocked) && <p className="mt-1 text-xs text-amber-600">Locked: this FD is matured/closed or already has posted vouchers.</p>}
        </Field>
        {form.linkedLedgerId === NEW_LEDGER_OPTION && !fieldsLocked && !ledgerLocked && (
          <Field label="New ledger name">
            <Input value={form.newLedgerName} onChange={(e) => setForm((f) => ({ ...f, newLedgerName: e.target.value }))} placeholder={form.fdNumber ? `FD ${form.fdNumber}` : "e.g. FD - HDFC 12345"} />
          </Field>
        )}
      </div>
      <div className="mt-3">
        <Field label="Notes">
          <Textarea rows={2} value={form.notes} onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))} />
        </Field>
      </div>
      <div className="mt-3 flex gap-2">
        <Button disabled={busy} onClick={onSubmit} className="bg-[#111827] text-white hover:bg-[#374151]">
          {isEdit ? <><Save className="mr-2 h-4 w-4" /> {submitLabel || "Save changes"}</> : <><Plus className="mr-2 h-4 w-4" /> {submitLabel || "Add fixed deposit"}</>}
        </Button>
        {onCancel && <Button type="button" variant="outline" disabled={busy} onClick={onCancel}>Cancel</Button>}
      </div>
    </div>
  );
}
